import { OptionsEditor } from "./OptionsEditor"
import type { ControlInspector } from "./types"

export const checkboxGroup: ControlInspector<"checkboxGroup"> = {
  Inspector: ({ field, onEdit }) => (
    <OptionsEditor
      eyebrow="Check box options"
      legend="Check box choices"
      options={field.options}
      onChange={(options) => onEdit({ options })}
    />
  ),
}
